import { WEEK_MOMENTS, checkDay, checkHour } from '../deleteOutHoursDRP';
import { SetHourOption } from './dynamicValuesToCallDate';

export function SpanishVersion() {
  
  const $modalInDeu = document.querySelector('.custom-budget--de')
  const $modalInSpanish = document.querySelector('.custom-budget')
  const $modalInEnglish = document.querySelector('.custom-budget--en')

  const a = new Date()
  // let b = a.

  const TEMPLATES_FOR_DATE_CALL = { SET_HOUR: SetHourOption()}

  if ($modalInSpanish !== null && $modalInEnglish === null && $modalInDeu === null) {

    const callDateSelect = document.getElementById('call_date-select')
    const callDateSelectWrap = document.getElementById('call_date-wrap')
    // Obtén el elemento select


    callDateSelect.addEventListener('change', function() {
      // Obtén el valor seleccionado
      const selectedValue = callDateSelect.value;
    
      // Obtén la fecha actual en la zona horaria local
      const currentDate = new Date();
      const timezoneOffset = currentDate.getTimezoneOffset();
      currentDate.setMinutes(currentDate.getMinutes() - timezoneOffset);
    
      // Obtén la fecha en el formato AAAA-MM-DD
      const year = currentDate.getFullYear();
      const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
      const day = currentDate.getDate().toString().padStart(2, '0');
      const formattedCurrentDate = `${year}-${month}-${day}`;
      let timestamp;

      if(selectedValue.includes('to')){

        // Separa la hora y el rango
        const [selectedDate, selectedRange] = selectedValue.split(' ');
      
        // Separa las horas de inicio y fin
        const [startHour] = selectedRange.split(' to');
      
        // Formatea la fecha seleccionada en el formato AAAA-MM-DD hh:mm:ss
        const formattedDate = `${formattedCurrentDate} ${startHour}:00:00`;
        timestamp = Date.parse(formattedDate) / 1000;
      }

    
      // console.log('El usuario seleccionó:', selectedValue);
      // console.log('Fecha formateada:', formattedDate);
      // console.log('Timestamp:', timestamp);
    
      if (selectedValue.includes('9 to 13h')) {
        // Añadir la fecha al objeto
        DFI.labels.EDeclaratives.Llamada_programada_AB = timestamp;
      } else if (selectedValue.includes('13 to 15h')) {
        DFI.labels.EDeclaratives.Llamada_programada_AB = timestamp;
        console.log("añadimos etiqueta de 13 a 15");
      } else if (selectedValue.includes('15 to 17h')) {
        DFI.labels.EDeclaratives.Llamada_programada_AB = timestamp;
      } else if (selectedValue.includes('17 to 20h')) {
        DFI.labels.EDeclaratives.Llamada_programada_AB = timestamp;
      } else {
        DFI.labels.EDeclaratives.Llamada_programada_AB = callDateSelect.options[callDateSelect.selectedIndex].text;
      }
      
    });

    // Introducimos el select dentro de la modal
    callDateSelect.innerHTML = TEMPLATES_FOR_DATE_CALL.SET_HOUR
  }
}
